<my-button>
    <button 
        type="{ props.type }" 
        disabled="{ props.is_disabled }" 
        class="inline-flex items-center gap-x-1.5 rounded-md bg-cyan-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-cyan-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-600">
        <slot />
    </button>
</my-button>
